import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Avatar from '@material-ui/core/Avatar';
import Box from '@material-ui/core/Box';
import Hidden from '@material-ui/core/Hidden';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItem from '@material-ui/core/ListItem';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import List from '@material-ui/core/List';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';

import AccountCircle from '@material-ui/icons/AccountCircle';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';

// import react-router
import { useHistory } from 'react-router-dom';

import { useDispatch } from 'react-redux';

import * as loginActions from './../../actions/login.action';

import {
  SYSTEM_NAME_FRONTOF,
  SYSTEM_NAME_FRONTOF_INIT,
  SYSTEM_NAME_FRONTOF_TH,
  SYSTEM_NAME_FRONTOF_INIT_TH,
  SYSTEM_NAME_BACKOF,
  SYSTEM_NAME_BACKOF_INIT,
} from './../../constants';

import { userProfiler } from './../../utils/utils';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: '36ch',
  },
  inline: {
    display: 'inline',
  },
  title: {
    display: 'flex',
    flexGrow: 1,
    alignItems: 'center',
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  avatarSmall: {
    width: theme.spacing(3.9),
    height: theme.spacing(3.9),
  },
  avatarLarge: {
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
}));

function InnerAppBar({ isAuthen = false, isBackOffice = false }) {
  // Classes
  const classes = useStyles();

  // Hook function from router
  const history = useHistory();

  // Hook dispatch
  const dispatch = useDispatch();

  const upf = userProfiler.getFromLocal();

  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  }

  /**
   * handleLogout()
   * Despatch loginActions.logout
   */
  function handleLogout() {
    dispatch(loginActions.logout(history));
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current && anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  return (
    <React.Fragment>
      {/* @System Name Text */}
      <Typography component="div" className={classes.title}>
        <img
          src={`${process.env.PUBLIC_URL}/images/mu_logo_without_text_tiny.png`}
        />
        <Box
          display="flex"
          flexDirection="column"
          alignItems="flex-start"
          justifyContent="space-evenly"
          style={{ paddingLeft: '10px' }}
        >
          {!isBackOffice && (
            <React.Fragment>
              {/* Laptop - SysName Top */}
              <Hidden smDown>
                <Box flexGrow={1} fontSize="h6.fontSize">
                  {SYSTEM_NAME_FRONTOF}
                </Box>
              </Hidden>
              {/* Mobile - SysName Top  */}
              <Hidden smUp>
                <Box flexGrow={1} fontSize={12}>
                  {SYSTEM_NAME_FRONTOF_INIT}{' '}
                </Box>
              </Hidden>
              {/* Laptop - SysName Bottom */}
              <Hidden smDown>
                <Box flexGrow={1} fontSize="fontSize">
                  {SYSTEM_NAME_FRONTOF_TH}
                </Box>
              </Hidden>
              {/* Mobile - SysName Bottom  */}
              <Hidden smUp>
                <Box flexGrow={1} fontSize={12}>
                  {SYSTEM_NAME_FRONTOF_INIT_TH}{' '}
                </Box>
              </Hidden>
            </React.Fragment>
          )}

          {isBackOffice && (
            <Box flexGrow={1} fontSize="h6.fontSize">
              <Hidden smUp>{SYSTEM_NAME_BACKOF_INIT}</Hidden>
              <Hidden smDown>{SYSTEM_NAME_BACKOF}</Hidden>
            </Box>
          )}
        </Box>
      </Typography>

      {isAuthen && (
        <div>
          <IconButton
            ref={anchorRef}
            aria-controls={open ? 'menu-list-grow' : undefined}
            aria-haspopup="true"
            onClick={handleToggle}
          >
            {!upf.user.image && <AccountCircle />}
            {upf.user.image && (
              <Avatar
                alt={upf.user.name}
                src={upf.user.image}
                className={classes.avatarSmall}
              />
            )}
          </IconButton>
          <Popper
            open={open}
            anchorEl={anchorRef.current}
            role={undefined}
            transition
            disablePortal
            className={classes.root}
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin:
                    placement === 'bottom' ? 'center top' : 'center bottom',
                }}
              >
                <Paper>
                  {upf.user.firstName && (
                    <React.Fragment>
                      <List>
                        <ListItem alignItems="center">
                          <ListItemAvatar>
                            <Avatar
                              alt={upf.user.firstName}
                              src={upf.user.image}
                              className={classes.avatarLarge}
                            />
                          </ListItemAvatar>
                          <ListItemText
                            primary=""
                            secondary={
                              <React.Fragment>
                                <Typography
                                  component="div"
                                  variant="body2"
                                  color="textPrimary"
                                  style={{ marginLeft: '5px' }}
                                >
                                  {`${upf.user.firstName} ${upf.user.lastName}`}
                                  <br />
                                  {upf.user.firstNameEn &&
                                    `${upf.user.firstNameEn} ${upf.user.lastNameEn}`}
                                </Typography>
                              </React.Fragment>
                            }
                          />
                        </ListItem>
                        {upf.user.lastLogin && (
                          <React.Fragment>
                            <Divider variant="middle" />
                            <ListItem alignItems="flex-start">
                              <ListItemText
                                primary=""
                                secondary={
                                  <React.Fragment>
                                    <Typography
                                      component="div"
                                      variant="body2"
                                      className={classes.inline}
                                      color="textPrimary"
                                    >
                                      <Box my={1}>
                                        อีเมล&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:{' '}
                                        {upf.user.email}
                                      </Box>
                                      <Box my={1}>
                                        ตำแหน่ง: {upf.user.position}
                                      </Box>
                                      <Box my={1}>
                                        ส่วนงาน&nbsp;:{' '}
                                        {upf.user.department}
                                      </Box>
                                      {/* <Box mt={3}>เข้าใช้ล่าสุด: {upf.user.lastLogin}</Box> */}
                                    </Typography>
                                  </React.Fragment>
                                }
                              />
                            </ListItem>{' '}
                          </React.Fragment>
                        )}
                      </List>
                      <Divider />
                    </React.Fragment>
                  )}
                  <ClickAwayListener onClickAway={handleClose}>
                    <MenuList
                      autoFocusItem={open}
                      id="menu-list-grow"
                      onKeyDown={handleListKeyDown}
                    >
                      {/* <MenuItem
                        onClick={() => {
                          alert('Link to Profile Page');
                        }}
                      >
                        <ListItemIcon>
                          <AccountBoxIcon fontSize="small" />
                        </ListItemIcon>
                        Profile
                      </MenuItem> */}
                      <MenuItem
                        onClick={(e) => {
                          handleLogout();
                          handleClose(e);
                        }}
                      >
                        <ListItemIcon>
                          <ExitToAppIcon fontSize="small" />
                        </ListItemIcon>
                        ออกจากระบบ
                      </MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </div>
      )}
    </React.Fragment>
  );
}

export default InnerAppBar;
